import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrums from "../../common/breadcrumbs";
import * as brandServices from "../../services/brand.services";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import { SWAL_SETTINGS, INPUT_LENGTH_500 } from "../../../../utils/Constants";
import { Tooltip, Whisper, Loader } from "rsuite";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const BrandEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [dataLoaded, setDataLoaded] = useState(false);
  const [saveType, setSaveType] = useState("");
  const [previewimage, setPreviewImage] = useState("");
  const { t } = useTranslation()


  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("link_brand"), url: "/admin/brand/list/1" },
    { title: t("link_edit"), url: "" },
  ];


  useEffect(() => {
    brandServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data?.data ? data.data : []);
        setPreviewImage(data && data?.data?.image ? data.data.image : "");
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          enableReinitialize
          initialValues={{
            title: showdefault && showdefault.title ? showdefault.title : "",
            files: showdefault && showdefault.image ? showdefault.image : "",
          }}
          validationSchema={Yup.object().shape({
            title: Yup.string()
              .required(t("label_title_error"))
              .max(INPUT_LENGTH_500, t("validation_err_reached_maximum_length")),
            files: Yup.mixed()
              .required(t("label_image_error"))
              .test("fileType", t("label_image_format_error"), (value) => {
                if (!value) return false;
                if (typeof value === "string") return true;
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return supportedFormats.includes(value.type);
              }),
          })}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", params.id);
            formData.append("title", values.title);
            if (values.files instanceof File) {
              formData.append("image", values.files);
            }
            brandServices
              .Edit(formData)
              .then((response) => {
                setSubmitting(false);
                if (response.success) {
                  Swal.fire({
                    icon: "success",
                    text: response.message,
                    ...SWAL_SETTINGS,
                  });
                  if (saveType !== "Save") {
                    setTimeout(() => {
                      resetForm({ values: "" });
                      globalLoader(false);
                      navigate(`/admin/brand/list/1`);
                    }, 1000);
                  }
                  if (saveType === "Save") {
                    setTimeout(() => {
                      globalLoader(false);
                    }, 1000);
                  }
                } else {
                  Swal.fire({
                    icon: "error",
                    text: handleServerValidations(response),
                    ...SWAL_SETTINGS,
                  });
                  globalLoader(false);
                }
              })
              .catch((error) => {
                console.log("error ====> ", error);
              });
          }}>
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <div>
                        <h6 className="main-content-label mb-3">{t("edit_brand")}</h6>
                      </div>
                      {showdefault && Object.keys(showdefault).length > 0 ? (
                        <div className="row row-sm">
                          <div className="col-lg-12 text-center form-group">
                            <label htmlFor="title" className="text-left d-flex">
                              {t("list_heading_title")}:<span className="requirestar">*</span>
                            </label>
                            <input name="title" id="title" type="text" onChange={handleChange} onBlur={handleBlur} value={values.title} className="form-control" placeholder={t("brand_title_placeholder")} />
                            <span className="text-danger d-flex text-left">{errors.title && touched.title && t(errors.title)}</span>
                          </div>

                          <div className="col-lg-12 text-center form-group">
                            <label htmlFor="files" className="text-left d-flex">
                              {t("label_image")}:<span className="requirestar">*</span>
                              <Whisper
                                placement="top"
                                controlId="control-id-hover"
                                trigger="hover"
                                speaker={
                                  <Tooltip>Recommended Size (1920x887)</Tooltip>
                                }
                              >
                                <span className="field-more-info mt-1 ms-1 cp">
                                  ?
                                </span>
                              </Whisper>
                            </label>
                            <input
                              className="form-control imgInput"
                              id="files"
                              name="files"
                              accept="image/*"
                              type="file"
                              onChange={(event) => {
                                setFieldValue(
                                  "files",
                                  event.currentTarget.files[0] || ""
                                );
                                event.currentTarget.files.length === 1
                                  ? setPreviewImage(
                                    URL.createObjectURL(
                                      event.currentTarget.files[0]
                                    )
                                  )
                                  : setPreviewImage("");
                              }}
                            />
                            <span
                              className="text-danger d-flex text-left"
                              id="errortext"
                            >
                              {errors.files && touched.files && errors.files}
                            </span>
                          </div>
                          {previewimage ? (
                            <ul className="question-image-preview questions-ul">
                              <li className="pr_img_box">
                                <img
                                  src={previewimage}
                                  style={{ height: "100px" }}
                                  alt={"img"}
                                />
                                <div className="img_options">
                                  <button type="button" className="text-danger"
                                    onClick={() => {
                                      setPreviewImage("");
                                      setFieldValue("files", null);
                                      document.getElementById("files").value = ""
                                    }}>
                                    <i className="ri-delete-bin-6-fill"></i>
                                  </button>
                                </div>
                              </li>
                            </ul>
                          ) : (
                            ""
                          )}

                          <div className="">
                            <button
                              onClick={() => {
                                setSaveType("Save");
                              }}
                              className="btn btn-info mr-2"
                              type="submit">
                              <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                              {t("btn_save")}
                            </button>
                            <button
                              onClick={() => {
                                setSaveType("");
                              }}
                              className="btn btn-success mr-2"
                              type="submit">
                              <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                              {t("btn_save_exit")}
                            </button>
                            <button className="btn ripple btn-secondary" type="button" onClick={() => navigate(-1)}>
                              <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                              {t("btn_cancel")}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <Loader />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default BrandEdit;
